import axios from "@/libs/axios";
// @ts-ignore
import AwsService from "./awsService";

const awsService: AwsService = new AwsService(axios);
export default awsService;
